export default __webpack_public_path__ + "dfc30e3ea384a623fb984fe818a919fc.svg";